import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {getJobsLoaded} from '@portal-ng/PNSAdminEntities/reducers';
import {PNSTaskService} from '@portal-ng/PNSServices/PNSTask.service';
import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {LoadPNSJobs} from '../../PNSAdminEntities/actions/PNSJobs.action';
import {IPNSJobsState} from '../../PNSAdminEntities/reducers/PNSJobs.reducer';

@Injectable()
export class PNSJobsGuard implements CanActivate {
  constructor(private taskService: PNSTaskService, private store: Store<IPNSJobsState>) {
  }

  canActivate(): Observable<boolean> {
    return this.getJobs().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false)),
    );
  }

  private getJobs(): Observable<any> {
    return this.store.pipe(
      select(getJobsLoaded),
      tap((jobsLoaded) => { if (!jobsLoaded) {
        this.store.dispatch(new LoadPNSJobs());
      }}),
      filter((jobsLoaded) => jobsLoaded),
      take(1),
    );
  }
}
